import { render, staticRenderFns } from "./EstadoResultados.vue?vue&type=template&id=3dc41a26&"
import script from "./EstadoResultados.vue?vue&type=script&lang=js&"
export * from "./EstadoResultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports